import { render, staticRenderFns } from "./AccountLog.vue?vue&type=template&id=640bceba&scoped=true&"
import script from "./AccountLog.vue?vue&type=script&lang=js&"
export * from "./AccountLog.vue?vue&type=script&lang=js&"
import style0 from "./AccountLog.vue?vue&type=style&index=0&id=640bceba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bceba",
  null
  
)

export default component.exports